import { render, staticRenderFns } from "./csv_import_export_buttons.vue?vue&type=template&id=383b87f2"
import script from "./csv_import_export_buttons.vue?vue&type=script&lang=js"
export * from "./csv_import_export_buttons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports